const energyPalette = {
	solar: "#E3B23C",
	battery: "#3A9D6F",
	grid: "#1777FF",
	consumption: "#E4774E",
	export: "#43A6A1",
};

export default energyPalette;
